export default ({ request }) => ({
  ecomAmzFtyCheckTaskListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/task/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckTaskDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/task/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckTaskSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/task/save',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckTaskDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/task/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckTaskStartCountingApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/task/startCounting',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckTaskStopCountingApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/task/stopCounting',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckTaskUpdateDataApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/task/updateData',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/detail/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckDetailPageListApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/detail/page/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckDelApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/del',
      method: 'POST',
      data,
    })
  },
  ecomAmzFtyCheckUpdateSaveApi(data = {}) {
    return request({
      url: '/ecom/amz/fty/check/update/save',
      method: 'POST',
      data,
    })
  },
})
